// import React, { useState, useEffect } from "react";
// import { months, mainData } from "./constanst/AnnualViewData";
// import "./annualTableStyles.css";

// const AnnualTotalTable = ({apiData}) => {
//   const styles = `
//      @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');

//      * {
//        margin: 0;
//        padding: 0;
//        box-sizing: border-box;
//      }

//      body {
//        min-height: 100vh;
//      }

//      .dashboard-container {
//        padding: 20px;
//        width: 100%;
//        opacity: 0;
//        transform: translateY(20px);
//        transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
//      }

//      .dashboard-container.fade-in {
//        opacity: 1;
//        transform: translateY(0);
//      }

//      .dashboard-header {
//        display: flex;
//        justify-content: space-between;
//        align-items: center;
//        margin-bottom: 30px;
//        animation: slideInFromTop 0.8s ease-out;
//      }

//      .dashboard-header h1 {
//        color: white;
//        font-size: 2.5rem;
//        font-weight: 700;
//        /* text-shadow: 0 4px 8px rgba(0,0,0,0.3); */
//        display: flex;
//        align-items: center;
//        gap: 15px;
//      }

//      .dashboard-header h1 i {
//        color: #ffd700;
//      }

//      .header-stats {
//        display: flex;
//        gap: 20px;
//      }

//      .stat-card {
//        background: rgba(255, 255, 255, 0.15);
//        backdrop-filter: blur(10px);
//        border: 1px solid rgba(255, 255, 255, 0.2);
//        border-radius: 15px;
//        padding: 20px;
//        display: flex;
//        align-items: center;
//        gap: 15px;
//        /* box-shadow: 0 8px 25px rgba(0,0,0,0.15); */
//        transform: translateY(0);
//        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//      }

//      .stat-card:hover {
//        transform: translateY(-5px);
//        /* box-shadow: 0 15px 35px rgba(0,0,0,0.25); */
//        background: rgba(255, 255, 255, 0.2);
//      }

//      .stat-card i {
//        font-size: 2rem;
//        color: #ffd700;
//      }

//      .stat-label {
//        display: block;
//        color: rgba(255, 255, 255, 0.8);
//        font-size: 0.9rem;
//        margin-bottom: 5px;
//      }

//      .stat-value {
//        display: block;
//        color: white;
//        font-size: 1.4rem;
//        font-weight: 700;
//      }

//      .table-container {
//        background: rgba(255, 255, 255, 0.95);
//        border-radius: 20px;
//        padding: 0;
//        width: 100%;
//        /* box-shadow: 0 20px 60px rgba(0,0,0,0.15); */
//        overflow: hidden;
//        backdrop-filter: blur(10px);
//        border: 1px solid rgba(255, 255, 255, 0.2);
//        animation: slideInFromBottom 0.8s ease-out 0.2s both;
//      }

//      .table-wrapper {
//        overflow-x: auto;
//        max-height: 80vh;
//        overflow-y: auto;
//      }

//      .financial-table {
//        width: 100%;
//        border-collapse: collapse;
//        font-size: clamp(1rem, 1.2rem, 1.5rem);
//      }

//      .financial-table thead {
//        position: sticky;
//        top: 0;
//        z-index: 10;
//      }

//      .financial-table th {
//        background: linear-gradient(135deg, #2c3e50, #3498db);
//        color: white;
//        padding: 15px 12px;
//        text-align: center;
//        font-weight: 600;
//        font-size: clamp(0.95rem, 1.1rem, 1.3rem);
//        border-right: 1px solid rgba(255,255,255,0.1);
//        position: relative;
//        overflow: hidden;
//      }

//      .financial-table th::before {
//        content: '';
//        position: absolute;
//        top: 0;
//        left: -100%;
//        width: 100%;
//        height: 100%;
//        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
//        transition: left 0.5s;
//      }

//      .financial-table th:hover::before {
//        left: 100%;
//      }

//      .row-header {
//        background: linear-gradient(135deg, #1a252f, #2c3e50) !important;
//        text-align: left !important;
//        min-width: 200px;
//        position: sticky;
//        left: 0;
//        z-index: 11;
//      }

//      .month-header {
//        min-width: 100px;
//        animation: fadeInScale 0.5s ease-out var(--delay);
//      }

//      .summary-header {
//        min-width: 90px;
//        font-size: 0.95rem;
//      }

//      .actual { background: linear-gradient(135deg, #27ae60, #2ecc71) !important; }
//      .budget { background: linear-gradient(135deg, #f39c12, #e67e22) !important; }
//      .percentage { background: linear-gradient(135deg, #9b59b6, #8e44ad) !important; }
//      .remaining { background: linear-gradient(135deg, #e74c3c, #c0392b) !important; }
//      .excess { background: linear-gradient(135deg, #16a085, #1abc9c) !important; }

//      .main-row, .sub-row, .amount-left-row {
//        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//        animation: slideInFromLeft 0.6s ease-out var(--delay);
//      }

//      .main-row:hover, .amount-left-row:hover {
//        background: linear-gradient(90deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
//        transform: scale(1.002);
//        /* box-shadow: 0 5px 15px rgba(0,0,0,0.1); */
//      }

//      .expandable {
//        cursor: pointer;
//      }

//      .expandable:hover {
//        background: linear-gradient(90deg, rgba(52, 152, 219, 0.1), rgba(155, 89, 182, 0.1)) !important;
//      }

//      .sub-row {
//        background: rgba(52, 152, 219, 0.05);
//        animation: expandDown 0.4s ease-out;
//        transform-origin: top;
//      }

//      .sub-row:nth-child(even) {
//        background: rgba(52, 152, 219, 0.08);
//      }

//      .sub-row:hover {
//        background: rgba(52, 152, 219, 0.15) !important;
//        transform: translateX(5px);
//      }

//      .amount-left-row {
//        background: linear-gradient(90deg, rgba(39, 174, 96, 0.1), rgba(46, 204, 113, 0.1));
//        border-top: 3px solid #27ae60;
//        font-weight: 600;
//      }

//      .row-label, .sub-row-label {
//        background: rgba(248, 249, 250, 0.8);
//        padding: 15px;
//        text-align: left;
//        font-weight: 600;
//        font-size: clamp(1rem, 1.2rem, 1.5rem);
//        border-right: 2px solid #e9ecef;
//        position: sticky;
//        left: 0;
//        z-index: 5;
//        min-width: 200px;
//      }

//      .total-label {
//        background: linear-gradient(90deg, rgba(39, 174, 96, 0.2), rgba(46, 204, 113, 0.2)) !important;
//        color: #27ae60;
//        font-weight: 700;
//      }

//      .total-value, .total-summary {
//        background: linear-gradient(90deg, rgba(39, 174, 96, 0.2), rgba(46, 204, 113, 0.2));
//        color: #27ae60;
//        font-weight: 700;
//        font-size: 1.2rem;
//      }

//      .label-content, .sub-label-content {
//        display: flex;
//        align-items: center;
//        gap: 10px;
//      }

//      .label-content i {
//        font-size: 1.2rem;
//        width: 20px;
//        text-align: center;
//        transition: all 0.3s ease;
//      }

//      .expand-icon {
//      }

//      .value-cell {
//        padding: 12px 8px;
//        text-align: right;
//        font-weight: 500;
//        font-size: clamp(1rem, 1.2rem, 1.5rem);
//        font-family: 'Courier New', monospace;
//        position: relative;
//        transition: all 0.3s ease;
//        border-bottom: 1px solid rgba(0,0,0,0.05);
//      }

//      .value-cell:hover {
//        background: rgba(52, 152, 219, 0.1);
//        transform: scale(1.05);
//        z-index: 2;
//        border-radius: 5px;
//        /* box-shadow: 0 2px 8px rgba(0,0,0,0.1); */
//      }

//      .positiveCell {
//        color: #27ae60;
//        font-weight: 600;
//      }

//      .negativeCell {
//        color: #e74c3c;
//        font-weight: 600;
//      }

//      .neutral {
//        color: #6c757d;
//      }

//      .sub-value {
//        font-size: 1rem;
//        background: rgba(255,255,255,0.5);
//      }

//      .summary-cell {
//        padding: 12px 8px;
//        text-align: right;
//        font-weight: 600;
//        font-family: 'Courier New', monospace;
//        background: rgba(248, 249, 250, 0.8);
//        border-left: 2px solid #dee2e6;
//      }

//      @keyframes slideInFromBottom {
//        from {
//          opacity: 0;
//          transform: translateY(50px);
//        }
//        to {
//          opacity: 1;
//          transform: translateY(0);
//        }
//      }

//      @keyframes slideInFromLeft {
//        from {
//          opacity: 0;
//          transform: translateX(-30px);
//        }
//        to {
//          opacity: 1;
//          transform: translateX(0);
//        }
//      }

//      @keyframes fadeInScale {
//        from {
//          opacity: 0;
//          transform: scale(0.8);
//        }
//        to {
//          opacity: 1;
//          transform: scale(1);
//        }
//      }

//      @keyframes expandDown {
//        from {
//          opacity: 0;
//          transform: scaleY(0);
//          max-height: 0;
//        }
//        to {
//          opacity: 1;
//          transform: scaleY(1);
//          max-height: 100px;
//        }
//      }

//      /* Responsive Design */
//      @media (max-width: 1200px) {
//        .financial-table {
//          font-size: 0.8rem;
//        }

//        .financial-table th,
//        .value-cell,
//        .summary-cell {
//          padding: 10px 6px;
//          min-width: 80px;
//        }
//      }

//      @media (max-width: 768px) {
//        .dashboard-header {
//          flex-direction: column;
//          gap: 20px;
//          text-align: center;
//        }

//        .dashboard-header h1 {
//          font-size: 2rem;
//        }
//      }

//      /* Custom scrollbar */
//      .table-wrapper::-webkit-scrollbar {
//        width: 8px;
//        height: 8px;
//      }

//      .table-wrapper::-webkit-scrollbar-track {
//        background: rgba(0,0,0,0.1);
//        border-radius: 4px;
//      }

//      .table-wrapper::-webkit-scrollbar-thumb {
//        background: linear-gradient(135deg, #667eea, #764ba2);
//        border-radius: 4px;
//      }

//      .table-wrapper::-webkit-scrollbar-thumb:hover {
//        background: linear-gradient(135deg, #5a6fd8, #6a4190);
//      }
//    `;

//   // Add styles to document head
//   React.useEffect(() => {
//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = styles;
//     document.head.appendChild(styleSheet);

//     const rows = document.querySelectorAll(".main-row, .amount-left-row");
//     rows.forEach((row, index) => {
//       row.style.setProperty("--delay", `${index * 0.1}s`);
//     });

//     const months = document.querySelectorAll(".month-header");
//     months.forEach((month, index) => {
//       month.style.setProperty("--delay", `${index * 0.05}s`);
//     });

//     return () => {
//       document.head.removeChild(styleSheet);
//     };
//   }, []);

//   const [expandedRows, setExpandedRows] = useState(new Set());
//   const [animationClass, setAnimationClass] = useState("");

//   useEffect(() => {
//     setAnimationClass("fade-in");

//     const rows = document.querySelectorAll(".main-row, .amount-left-row");
//     rows.forEach((row, index) => {
//       row.style.setProperty("--delay", `${index * 0.1}s`);
//     });

//     const monthHeaders = document.querySelectorAll(".month-header");
//     monthHeaders.forEach((month, index) => {
//       month.style.setProperty("--delay", `${index * 0.05}s`);
//     });
//   }, []);

//   const toggleRow = (rowId) => {
//     setExpandedRows((prev) => {
//       const newSet = new Set(prev);
//       if (newSet.has(rowId)) {
//         newSet.delete(rowId);
//       } else {
//         newSet.add(rowId);
//       }
//       return newSet;
//     });
//   };

//   const calculateAmountLeft = (index) => {
//     let total = mainData[0].values[index];
//     for (let i = 1; i < mainData.length; i++) {
//       total += mainData[i].values[index];
//     }
//     return total;
//   };

//   const formatCurrency = (value) => {
//     const absValue = Math.abs(value);
//     return `${value < 0 ? "-" : ""}$${absValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//   };

//   const getValueClass = (value) => {
//     if (value > 0) return "positiveCell";
//     if (value < 0) return "negativeCell";
//     return "neutral";
//   };

//   return (
//     <div
//       className={`dashboard-container ${animationClass}`}
//       style={{ width: "100%" }}
//     >
//       <div className="table-container">
//         <div className="table-wrapper">
//           <table className="financial-table">
//             <thead>
//               <tr>
//                 <th className="row-header">ANNUAL TOTAL</th>
//                 {months.map((month, index) => (
//                   <th key={month} className={`month-header month-${index}`}>
//                     {month}
//                   </th>
//                 ))}
//                 <th className="summary-header actual">ACTUAL</th>
//                 <th className="summary-header budget">BUDGET</th>
//                 <th className="summary-header percentage">%</th>
//                 <th className="summary-header remaining">REMAINING</th>
//                 <th className="summary-header excess">EXCESS</th>
//               </tr>
//             </thead>
//             <tbody>
//               {mainData.map((row, rowIndex) => (
//                 <React.Fragment key={row.id}>
//                   <tr
//                     className={`main-row ${row.expandable ? "expandable" : ""} row-${rowIndex}`}
//                     onClick={() => row.expandable && toggleRow(row.id)}
//                   >
//                     <td className="row-label">
//                       <div className="label-content">
//                         <i className={`fa ${row.icon}`}></i>
//                         <span>{row.label}</span>
//                         {row.expandable && (
//                           <i
//                             className={`fa fa-chevron-${expandedRows.has(row.id) ? "down" : "right"} expand-icon`}
//                           ></i>
//                         )}
//                       </div>
//                     </td>
//                     {row.values.map((value, colIndex) => (
//                       <td
//                         key={colIndex}
//                         className={`value-cell ${getValueClass(value)} col-${colIndex}`}
//                       >
//                         {formatCurrency(value)}
//                       </td>
//                     ))}
//                     <td
//                       className={`summary-cell ${getValueClass(row.values.reduce((a, b) => a + b, 0))}`}
//                     >
//                       {formatCurrency(row.values.reduce((a, b) => a + b, 0))}
//                     </td>
//                     <td className="summary-cell budget-cell">-</td>
//                     <td className="summary-cell percentage-cell">-</td>
//                     <td className="summary-cell remaining-cell">-</td>
//                     <td className="summary-cell excess-cell">-</td>
//                   </tr>

//                   {row.expandable &&
//                     expandedRows.has(row.id) &&
//                     row.subItems &&
//                     row.subItems.map((subItem, subIndex) => (
//                       <tr
//                         key={`${row.id}-sub-${subIndex}`}
//                         className={`sub-row sub-row-${subIndex}`}
//                       >
//                         <td className="sub-row-label">
//                           <div className="sub-label-content">
//                             <span className="sub-indent">└─</span>
//                             <span>{subItem.label}</span>
//                           </div>
//                         </td>
//                         {subItem.values.map((value, colIndex) => (
//                           <td
//                             key={colIndex}
//                             className={`value-cell sub-value ${getValueClass(value)}`}
//                           >
//                             {formatCurrency(value)}
//                           </td>
//                         ))}
//                         <td
//                           className={`summary-cell sub-summary ${getValueClass(subItem.values.reduce((a, b) => a + b, 0))}`}
//                         >
//                           {formatCurrency(
//                             subItem.values.reduce((a, b) => a + b, 0),
//                           )}
//                         </td>
//                         <td className="summary-cell budget-cell">-</td>
//                         <td className="summary-cell percentage-cell">-</td>
//                         <td className="summary-cell remaining-cell">-</td>
//                         <td className="summary-cell excess-cell">-</td>
//                       </tr>
//                     ))}
//                 </React.Fragment>
//               ))}

//               <tr className="amount-left-row">
//                 <td className="row-label total-label">
//                   <div className="label-content">
//                     <i className="fa fa-calculator"></i>
//                     <span>Amount Left</span>
//                   </div>
//                 </td>
//                 {months.map((_, index) => (
//                   <td
//                     key={index}
//                     className={`value-cell total-value ${getValueClass(calculateAmountLeft(index))}`}
//                   >
//                     {formatCurrency(calculateAmountLeft(index))}
//                   </td>
//                 ))}
//                 <td className="summary-cell total-summary">
//                   {formatCurrency(calculateAmountLeft(months.length - 1))}
//                 </td>
//                 <td className="summary-cell budget-cell">-</td>
//                 <td className="summary-cell percentage-cell">-</td>
//                 <td className="summary-cell remaining-cell">-</td>
//                 <td className="summary-cell excess-cell">-</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AnnualTotalTable;





import React, { useState, useEffect } from "react";
import "./annualTableStyles.css";

const AnnualTotalTable = ({ apiData }) => {
  const styles = `
     @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
     
     * {
       margin: 0;
       padding: 0;
       box-sizing: border-box;
     }
 
     body {
       min-height: 100vh;
     }
 
     .dashboard-container {
       padding: 20px 0;
       width: 100%;
       opacity: 0;
       transform: translateY(20px);
       transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
     }
 
     .dashboard-container.fade-in {
       opacity: 1;
       transform: translateY(0);
     }
 
     .dashboard-header {
       display: flex;
       justify-content: space-between;
       align-items: center;
       margin-bottom: 30px;
       animation: slideInFromTop 0.8s ease-out;
     }
 
     .dashboard-header h1 {
       color: white;
       font-size: 2.5rem;
       font-weight: 700;
       /* text-shadow: 0 4px 8px rgba(0,0,0,0.3); */
       display: flex;
       align-items: center;
       gap: 15px;
     }
 
     .dashboard-header h1 i {
       color: #ffd700;
     }
 
     .header-stats {
       display: flex;
       gap: 20px;
     }
 
     .stat-card {
       background: rgba(255, 255, 255, 0.15);
       backdrop-filter: blur(10px);
       border: 1px solid rgba(255, 255, 255, 0.2);
       border-radius: 15px;
       padding: 20px;
       display: flex;
       align-items: center;
       gap: 15px;
       /* box-shadow: 0 8px 25px rgba(0,0,0,0.15); */
       transform: translateY(0);
       transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
     }
 
     .stat-card:hover {
       transform: translateY(-5px);
       /* box-shadow: 0 15px 35px rgba(0,0,0,0.25); */
       background: rgba(255, 255, 255, 0.2);
     }
 
     .stat-card i {
       font-size: 2rem;
       color: #ffd700;
     }
 
     .stat-label {
       display: block;
       color: rgba(255, 255, 255, 0.8);
       font-size: 0.9rem;
       margin-bottom: 5px;
     }
 
     .stat-value {
       display: block;
       color: white;
       font-size: 1.4rem;
       font-weight: 700;
     }
 
     .table-container {
       margin-right:0;
       background: rgba(255, 255, 255, 0.95);
       border-radius: 20px;
       padding: 0;
       width: 100%;
       /* box-shadow: 0 20px 60px rgba(0,0,0,0.15); */
       overflow: hidden;
       backdrop-filter: blur(10px);
       border: 1px solid rgba(255, 255, 255, 0.2);
       animation: slideInFromBottom 0.8s ease-out 0.2s both;
     }
 
     .table-wrapper {
       overflow-x: auto;
       max-height: 80vh;
       overflow-y: auto;
     }
 
     .financial-table {
       width: 100%;
       border-collapse: collapse;
       font-size: clamp(1rem, 1.2rem, 1.5rem);
     }
 
     .financial-table thead {
       position: sticky;
       top: 0;
       z-index: 10;
     }
 
     .financial-table th {
       background: linear-gradient(135deg, #2c3e50, #3498db);
       color: white;
       padding: 15px 12px;
       text-align: center;
       font-weight: 600;
       font-size: clamp(0.95rem, 1.1rem, 1.3rem);
       border-right: 1px solid rgba(255,255,255,0.1);
       position: relative;
       overflow: hidden;
     }
 
     .financial-table th::before {
       content: '';
       position: absolute;
       top: 0;
       left: -100%;
       width: 100%;
       height: 100%;
       background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
       transition: left 0.5s;
     }
 
     .financial-table th:hover::before {
       left: 100%;
     }
 
     .row-header {
       background: linear-gradient(135deg, #1a252f, #2c3e50) !important;
       text-align: left !important;
       min-width: 200px;
       position: sticky;
       left: 0;
       z-index: 11;
     }
 
     .month-header {
       min-width: 100px;
       animation: fadeInScale 0.5s ease-out var(--delay);
     }
 
     .summary-header {
       min-width: 90px;
       font-size: 0.95rem;
     }
 
     .actual { background: linear-gradient(135deg, #27ae60, #2ecc71) !important; }
     .budget { background: linear-gradient(135deg, #f39c12, #e67e22) !important; }
     .percentage { background: linear-gradient(135deg, #9b59b6, #8e44ad) !important; }
     .remaining { background: linear-gradient(135deg, #e74c3c, #c0392b) !important; }
     .excess { background: linear-gradient(135deg, #16a085, #1abc9c) !important; }
 
     .main-row, .sub-row, .amount-left-row {
       transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
       animation: slideInFromLeft 0.6s ease-out var(--delay);
     }
 
     .main-row:hover, .amount-left-row:hover {
       background: linear-gradient(90deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
       transform: scale(1.002);
       /* box-shadow: 0 5px 15px rgba(0,0,0,0.1); */
     }
 
     .expandable {
       cursor: pointer;
     }
 
     .expandable:hover {
       background: linear-gradient(90deg, rgba(52, 152, 219, 0.1), rgba(155, 89, 182, 0.1)) !important;
     }
 
     .sub-row {
       background: rgba(52, 152, 219, 0.05);
       animation: expandDown 0.4s ease-out;
       transform-origin: top;
     }
 
     .sub-row:nth-child(even) {
       background: rgba(52, 152, 219, 0.08);
     }
 
     .sub-row:hover {
       background: rgba(52, 152, 219, 0.15) !important;
       transform: translateX(5px);
     }
 
     .amount-left-row {
       background: linear-gradient(90deg, rgba(39, 174, 96, 0.1), rgba(46, 204, 113, 0.1));
       border-top: 3px solid #27ae60;
       font-weight: 600;
     }
 
     .row-label, .sub-row-label {
       background: rgba(248, 249, 250, 0.8);
       padding: 15px;
       text-align: left;
       font-weight: 600;
       font-size: clamp(1rem, 1.2rem, 1.5rem);
       border-right: 2px solid #e9ecef;
       position: sticky;
       left: 0;
       z-index: 5;
       min-width: 200px;
     }
 
     .total-label {
       background: linear-gradient(90deg, rgba(39, 174, 96, 0.2), rgba(46, 204, 113, 0.2)) !important;
       color: #27ae60;
       font-weight: 700;
     }
 
     .total-value, .total-summary {
       background: linear-gradient(90deg, rgba(39, 174, 96, 0.2), rgba(46, 204, 113, 0.2));
       color: #27ae60;
       font-weight: 700;
       font-size: 1.2rem;
     }
 
     .label-content, .sub-label-content {
       display: flex;
       align-items: center;
       gap: 10px;
     }
 
     .label-content i {
       font-size: 1.2rem;
       width: 20px;
       text-align: center;
       transition: all 0.3s ease;
     }
 
     .expand-icon {
     }
 
     .value-cell {
       padding: 12px 8px;
       text-align: right;
       font-weight: 500;
       font-size: clamp(1rem, 1.2rem, 1.5rem);
       font-family: 'Courier New', monospace;
       position: relative;
       transition: all 0.3s ease;
       border-bottom: 1px solid rgba(0,0,0,0.05);
     }
 
     .value-cell:hover {
       background: rgba(52, 152, 219, 0.1);
       transform: scale(1.05);
       z-index: 2;
       border-radius: 5px;
       /* box-shadow: 0 2px 8px rgba(0,0,0,0.1); */
     }
 
     .positiveCell {
       color: #27ae60;
       font-weight: 600;
     }
 
     .negativeCell {
       color: #e74c3c;
       font-weight: 600;
     }
 
     .neutral {
       color: #6c757d;
     }
 
     .sub-value {
       font-size: 1rem;
       background: rgba(255,255,255,0.5);
     }
 
     .summary-cell {
       padding: 12px 8px;
       text-align: right;
       font-weight: 600;
       font-family: 'Courier New', monospace;
       background: rgba(248, 249, 250, 0.8);
       border-left: 2px solid #dee2e6;
     }
 
     @keyframes slideInFromBottom {
       from {
         opacity: 0;
         transform: translateY(50px);
       }
       to {
         opacity: 1;
         transform: translateY(0);
       }
     }
 
     @keyframes slideInFromLeft {
       from {
         opacity: 0;
         transform: translateX(-30px);
       }
       to {
         opacity: 1;
         transform: translateX(0);
       }
     }
 
     @keyframes fadeInScale {
       from {
         opacity: 0;
         transform: scale(0.8);
       }
       to {
         opacity: 1;
         transform: scale(1);
       }
     }
 
     @keyframes expandDown {
       from {
         opacity: 0;
         transform: scaleY(0);
         max-height: 0;
       }
       to {
         opacity: 1;
         transform: scaleY(1);
         max-height: 100px;
       }
     }
 
     /* Responsive Design */
     @media (max-width: 1200px) {
       .financial-table {
         font-size: 0.8rem;
       }
       
       .financial-table th,
       .value-cell,
       .summary-cell {
         padding: 10px 6px;
         min-width: 80px;
       }
     }
 
     @media (max-width: 768px) {
       .dashboard-header {
         flex-direction: column;
         gap: 20px;
         text-align: center;
       }
       
       .dashboard-header h1 {
         font-size: 2rem;
       }
     }
 
     /* Custom scrollbar */
     .table-wrapper::-webkit-scrollbar {
       width: 8px;
       height: 8px;
     }
 
     .table-wrapper::-webkit-scrollbar-track {
       background: rgba(0,0,0,0.1);
       border-radius: 4px;
     }
 
     .table-wrapper::-webkit-scrollbar-thumb {
       background: linear-gradient(135deg, #667eea, #764ba2);
       border-radius: 4px;
     }
 
     .table-wrapper::-webkit-scrollbar-thumb:hover {
       background: linear-gradient(135deg, #5a6fd8, #6a4190);
     }
   `;

  React.useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
    return () => document.head.removeChild(styleSheet);
  }, []);

  const [expandedRows, setExpandedRows] = useState(new Set());
  const [animationClass, setAnimationClass] = useState("");

  useEffect(() => {
    setAnimationClass("fade-in");
  }, []);

  // ✅ Transform API data into table-ready format
  const { months, mainData } = React.useMemo(() => {
    const raw = apiData?.api2;
    if (!raw || !raw.months || !raw.data) {
      return { months: [], mainData: [] };
    }

    // months array for headers e.g. ["MARCH 2026", "APRIL 2026"]
    const months = raw.months;

    const getRow = (type) =>
      raw.data.find((d) => d.type === type);

    const incomeRow = getRow("INCOME");
    const expenseRow = getRow("EXPENSE");
    const balanceRow = getRow("BALANCE");

    // Helper: get ordered values aligned to months
    const getValues = (row) =>
      months.map((_, i) => row?.values?.[i]?.amount ?? 0);

    // For EXPENSE subItems: each categoryBreakdown per month
    // Build subItems by collecting all unique category names across all months
    const allCategories = [
      ...new Set(
        (expenseRow?.values || []).flatMap((v) =>
          (v.categoryBreakdown || []).map((c) => c.categoryName)
        )
      ),
    ];

    const expenseSubItems = allCategories.map((catName) => ({
      label: catName,
      values: (expenseRow?.values || []).map((monthVal) => {
        const cat = (monthVal.categoryBreakdown || []).find(
          (c) => c.categoryName === catName
        );
        // Expenses shown as negative
        return cat ? -Math.abs(cat.amount) : 0;
      }),
    }));

    const mainData = [
      incomeRow && {
        id: "income",
        label: "Income",
        icon: "fa-arrow-up",
        expandable: false,
        values: getValues(incomeRow),
      },
      expenseRow && {
        id: "expenses",
        label: "Expenses",
        icon: "fa-arrow-down",
        expandable: allCategories.length > 0,
        // Expenses as negative
        values: getValues(expenseRow).map((v) => -Math.abs(v)),
        subItems: expenseSubItems,
      },
      balanceRow && {
        id: "balance",
        label: "Balance",
        icon: "fa-balance-scale",
        expandable: false,
        values: getValues(balanceRow),
      },
    ].filter(Boolean);

    return { months, mainData };
  }, [apiData?.api2]);

  const toggleRow = (rowId) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      newSet.has(rowId) ? newSet.delete(rowId) : newSet.add(rowId);
      return newSet;
    });
  };

  // ✅ "Amount Left" = sum of all row values per month index
  const calculateAmountLeft = (index) =>
    mainData.reduce((sum, row) => sum + (row.values[index] ?? 0), 0);

  const formatCurrency = (value) => {
    const absValue = Math.abs(value);
    return `${value < 0 ? "-" : ""}₹${absValue.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const getValueClass = (value) => {
    if (value > 0) return "positiveCell";
    if (value < 0) return "negativeCell";
    return "neutral";
  };

  if (!months.length) {
    return <div style={{ padding: 20 }}>No data available.</div>;
  }

  return (
    <div className={`dashboard-container ${animationClass}`} style={{ width: "100%" }}>
      <div className="table-container">
        <div className="table-wrapper">
          <table className="financial-table">
            <thead>
              <tr>
                <th className="row-header">ANNUAL TOTAL</th>
                {months.map((month, index) => (
                  <th key={month} className={`month-header month-${index}`}>
                    {month}
                  </th>
                ))}
                {/* <th className="summary-header actual">ACTUAL</th>
                <th className="summary-header budget">BUDGET</th>
                <th className="summary-header percentage">%</th>
                <th className="summary-header remaining">REMAINING</th>
                <th className="summary-header excess">EXCESS</th> */}
              </tr>
            </thead>
            <tbody>
              {mainData.map((row, rowIndex) => (
                <React.Fragment key={row.id}>
                  <tr
                    className={`main-row ${row.expandable ? "expandable" : ""} row-${rowIndex}`}
                    onClick={() => row.expandable && toggleRow(row.id)}
                  >
                    <td className="row-label">
                      <div className="label-content">
                        <i className={`fa ${row.icon}`}></i>
                        <span>{row.label}</span>
                        {row.expandable && (
                          <i
                            className={`fa fa-chevron-${expandedRows.has(row.id) ? "down" : "right"} expand-icon`}
                          />
                        )}
                      </div>
                    </td>
                    {row.values.map((value, colIndex) => (
                      <td
                        key={colIndex}
                        className={`value-cell ${getValueClass(value)}`}
                      >
                        {formatCurrency(value)}
                      </td>
                    ))}
                    {/* ✅ ACTUAL = sum of all month values for this row */}
                    {/* <td className={`summary-cell ${getValueClass(row.values.reduce((a, b) => a + b, 0))}`}>
                      {formatCurrency(row.values.reduce((a, b) => a + b, 0))}
                    </td>
                    <td className="summary-cell">-</td>
                    <td className="summary-cell">-</td>
                    <td className="summary-cell">-</td>
                    <td className="summary-cell">-</td> */}
                  </tr>

                  {/* ✅ Expandable category breakdown for EXPENSE */}
                  {row.expandable &&
                    expandedRows.has(row.id) &&
                    row.subItems?.map((subItem, subIndex) => (
                      <tr key={`${row.id}-sub-${subIndex}`} className="sub-row">
                        <td className="sub-row-label">
                          <div className="sub-label-content">
                            <span className="sub-indent">└─</span>
                            <span>{subItem.label}</span>
                          </div>
                        </td>
                        {subItem.values.map((value, colIndex) => (
                          <td
                            key={colIndex}
                            className={`value-cell sub-value ${getValueClass(value)}`}
                          >
                            {formatCurrency(value)}
                          </td>
                        ))}
                        {/* <td className={`summary-cell ${getValueClass(subItem.values.reduce((a, b) => a + b, 0))}`}>
                          {formatCurrency(subItem.values.reduce((a, b) => a + b, 0))}
                        </td>
                        <td className="summary-cell">-</td>
                        <td className="summary-cell">-</td>
                        <td className="summary-cell">-</td>
                        <td className="summary-cell">-</td> */}
                      </tr>
                    ))}
                </React.Fragment>
              ))}

              {/* ✅ Amount Left row */}
              <tr className="amount-left-row">
                <td className="row-label total-label">
                  <div className="label-content">
                    <i className="fa fa-calculator"></i>
                    <span>Amount Left</span>
                  </div>
                </td>
                {months.map((_, index) => (
                  <td
                    key={index}
                    className={`value-cell total-value ${getValueClass(calculateAmountLeft(index))}`}
                  >
                    {formatCurrency(calculateAmountLeft(index))}
                  </td>
                ))}
                {/* <td className={`summary-cell total-summary ${getValueClass(months.reduce((sum, _, i) => sum + calculateAmountLeft(i), 0))}`}>
                  {formatCurrency(months.reduce((sum, _, i) => sum + calculateAmountLeft(i), 0))}
                </td>
                <td className="summary-cell">-</td>
                <td className="summary-cell">-</td>
                <td className="summary-cell">-</td>
                <td className="summary-cell">-</td> */}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AnnualTotalTable;